import { ref, computed, watch } from 'vue'

export function useAssignedTests({
  api,
  isAssignedTestMode,
  isMistakeReviewMode,
  isExamMode,
  selectedMode,
  selectedTopics
}) {
  const assignedTests = ref([])
  const assignedTestsLoading = ref(false)
  const selectedAssignedTestId = ref(null)
  const activeAssignedTestId = ref(null)
  const activeAssignedTestMeta = ref(null)

  const hasAssignedTests = computed(() => assignedTests.value.length > 0)
  const currentAssignedTest = computed(() => {
    if (!selectedAssignedTestId.value) return null
    return assignedTests.value.find(item => item.id === selectedAssignedTestId.value) || null
  })

  const assignedTestOptions = computed(() => (
    assignedTests.value.map(item => ({
      title: `${item.title} (${item.questionCount})`,
      value: item.id
    }))
  ))

  const clearAssignedTestSession = () => {
    activeAssignedTestId.value = null
    activeAssignedTestMeta.value = null
  }

  const loadAssignedTests = async () => {
    assignedTestsLoading.value = true

    try {
      const response = await api.get('/tests/assignments')
      assignedTests.value = Array.isArray(response.data?.assignments)
        ? response.data.assignments
        : []

      if (!assignedTests.value.length) {
        selectedAssignedTestId.value = null
        if (isAssignedTestMode.value) {
          isAssignedTestMode.value = false
        }
        return
      }

      const selectedExists = assignedTests.value.some(item => item.id === selectedAssignedTestId.value)
      if (!selectedExists) {
        selectedAssignedTestId.value = assignedTests.value[0].id
      }
    } catch (error) {
      assignedTests.value = []
      selectedAssignedTestId.value = null
      if (isAssignedTestMode.value) {
        isAssignedTestMode.value = false
      }
    } finally {
      assignedTestsLoading.value = false
    }
  }

  watch(isAssignedTestMode, (enabled) => {
    if (!enabled) return

    isMistakeReviewMode.value = false
    isExamMode.value = false
    selectedMode.value = 'TRAINING_MODE'
    selectedTopics.value = ['ALL_TOPICS']

    if (!assignedTests.value.length && !assignedTestsLoading.value) {
      loadAssignedTests()
    }
  })

  watch(assignedTests, (items) => {
    if (!items.length) {
      selectedAssignedTestId.value = null
      if (isAssignedTestMode.value) {
        isAssignedTestMode.value = false
      }
      return
    }

    const selectedExists = items.some(item => item.id === selectedAssignedTestId.value)
    if (!selectedExists) {
      selectedAssignedTestId.value = items[0].id
    }
  }, { deep: true })

  return {
    assignedTests,
    assignedTestsLoading,
    selectedAssignedTestId,
    activeAssignedTestId,
    activeAssignedTestMeta,
    hasAssignedTests,
    currentAssignedTest,
    assignedTestOptions,
    clearAssignedTestSession,
    loadAssignedTests
  }
}
